(function() {
  document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;
      // Don't return the default template and return a custom two-column layout instead
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left">
              ${displaySuggestions &&
              html`<div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle">Suggestions</span>
                <div class="aa-SourceHeaderLine" />
              </div>
              ${elements.querySuggestionsPlugin}`}
              ${elements.collections}
              ${elements.articles}
              ${elements.pages}
            </div>
            <div class="aa-PanelSection--right">
              ${elements.products}
            </div>
          </div>
        </div>
      `
    });
  });
})();
